import React, { PropsWithChildren } from 'react';
import { socket } from '../../constants/socket';
import { SocketContext } from './context';
import useUser from '../../hooks/global/useUser';

export function SocketProvider({ children }: PropsWithChildren) {
  const { user } = useUser();

  React.useEffect(() => {
    const businessId = user?.business?.id;

    const register = () => {
      if (businessId) {
        socket.emit('register', { businessId });
      }
    };

    // Re-register on every (re)connect: each reconnect creates a new
    // server-side socket with no room membership.
    socket.on('connect', register);

    // Force a fresh handshake: the auth token only exists after login, and
    // handshake auth is captured per connection attempt.
    if (socket.connected) {
      socket.disconnect();
    }
    socket.connect();

    return () => {
      socket.off('connect', register);
      socket.disconnect();
    };
  }, [user?.business?.id]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
}
